import React from "react";
import "./Contact.css";
import { FaEnvelope, FaPhoneAlt } from "react-icons/fa";

export default function Contact() {
  return (
    <main className="Contact">
      <div className="card contact-card">
        <p className="section-eyebrow">Get In Touch</p>
        <h1>Let's Schedule Your Next Visit</h1>
        <p className="contact-lead">
          Reach out to Dr. Harteis directly — no call centers, no runaround.
        </p>

        <div className="contact-methods">
          <a className="contact-item" href="mailto:harteispt@gmail.com">
            <span className="icon"><FaEnvelope size={20} /></span>
            <span>harteispt@gmail.com</span>
          </a>
          <a className="contact-item" href="tel:+18145259768">
            <span className="icon"><FaPhoneAlt size={18} /></span>
            <span>(814) 525-9768</span>
          </a>
        </div>

        <a className="btn btn-primary" href="mailto:harteispt@gmail.com">Email Dr. Harteis</a>
      </div>
    </main>
  );
}
